import { ITreeNode } from "./ITreeNode";

export class InfoNode<T, C> extends ITreeNode<T, C> {
    constructor(identifier: string, data: T) {
        super(identifier, data);
    }
}
